<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-md-6 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item"><a href="#">Skill</a></li>
              <li class="breadcrumb-item active" aria-current="page">Edit Skill</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-6 col-sm-12 text-right">
          <router-link
            :to="'/admin/master/skill'"
            class="btn btn-outline-danger"
            title="Go to Skill"
            ><i class="fa fa-arrow-circle-left mr-2"></i>Back</router-link
          >
        </div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-md-8 mx-auto">
        <div class="card">
          <div class="card-header bg-primary custom-title theme-backcolor">
            <h6 class="text-white fs">Edit Skill</h6>
          </div>
          <!---->
          <v-app class="fixVapp">
            <div class="body">
              <form>
                <div class="form-group">
                  <label class="text-muted">Select Category</label>
                  <v-autocomplete
                    attach
                    label=""
                    v-model="selected"
                    :items="categories"
                    item-text="category_title"
                    item-value="category_id"
                    outlined
                    dense
                    class="mt-n8"
                    :error-messages="errors.category_id"
                  ></v-autocomplete>
                </div>
                <div class="form-group mt-n4">
                  <label class="text-muted">Skill Title</label>
                  <v-text-field
                    type="text"
                    name="skill_title"
                    v-model="skill_title"
                    label=""
                    outlined
                    dense
                    class="mt-n8"
                    :error-messages="errors.skill_title"
                  />
                </div>
                <div class="form-group mt-n4">
                  <label class="text-muted">Description</label>
                  <v-text-field
                    type="text"
                    name="skill_description"
                    v-model="skill_description"
                    label=""
                    outlined
                    class="mt-n8"
                    dense
                    :error-messages="errors.skill_description"
                  />
                </div>
                <div class="mx-auto col-md-3 mt-n3">
                  <button
                    type="button"
                    class="btn btn-primary text-white theme-backcolor"
                    @click="SkillUpdate"
                  >
                    <i class="fa fa-save mr-2"></i>Update
                  </button>
                </div>
              </form>
            </div>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from '../../../dataservice';
export default {
  components: {},
  data() {
    return {
      errors: '',
      categories: [],
      selected: null,
      skill_id: 0,
      skill_title: '',
      skill_description: '',
      category_id: '',
      skill_isactive: '',
      Isactive: null,
    };
  },
  methods: {
    getSkill(id) {
      DataService.getSkillById(id).then(response => {
        const _getData = response.data[0];
        this.skill_id = _getData.skill_id;
        this.skill_title = _getData.skill_title;
        this.skill_description = _getData.skill_description;
        this.skill_isactive = _getData.skill_isactive;
        // setting here category Title for drop down selected value
        // this.selected = _getData.category_title;
        this.selected = _getData.category_id;
      });
    },
    SkillUpdate() {
      const data = new FormData();
      data.append('skill_title', this.skill_title);
      data.append('skill_description', this.skill_description);
      data.append('category_id', this.selected);
      data.append('skill_isactive', this.skill_isactive);
      DataService.updateSkill(this.skill_id, data)
        .then(response => {
          this.s('Skill', 'Record Updated successfully !');
          this.$router.push({ name: 'skill' });
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.e("Oop's", 'Something went wrong.');
        });
    },
  },
  created() {
    DataService.getAllCategory()
      .then(response => {
        this.categories = response.data;
      })
      .catch(e => {
        // console.log(e);
      });
    this.getSkill(this.$route.params.id);
  },
};
</script>
<style scoped>
.fixVapp {
  height: 100px;
}
.custom-title {
  padding: 8px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>
